function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import Common from "../components/includes/Common";
import moment from "moment";
import { DatePicker, Space, Table, Button, Tabs, Drawer, Image, Descriptions } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { Excel } from "antd-table-saveas-excel";
import { PrinterFill, CheckCircleFill } from "react-bootstrap-icons";
import Moment from "react-moment";
import Receipt from "./Receipt";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var TabPane = Tabs.TabPane;
var SettlementHistory = function SettlementHistory(_ref) {
  var _ref$bill = _ref.bill,
    bill = _ref$bill === void 0 ? null : _ref$bill;
  var ref = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    settlements = _useState4[0],
    setSettlements = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showReceipt = _useState6[0],
    setShowReceipt = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedSettlement = _useState8[0],
    setSelectedSettlement = _useState8[1];
  var cols = [{
    title: "Date",
    dataIndex: "date",
    render: function render(date) {
      return /*#__PURE__*/_jsx(Moment, {
        format: "DD/MM/YYYY HH:mm",
        date: date
      });
    },
    key: "date"
  }, {
    title: "Montant",
    dataIndex: "amount",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text.toLocaleString("Fr")
      });
    },
    key: "amount"
  }, {
    title: "Agent",
    dataIndex: "user",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "user"
  }, {
    title: "Mode de paiement",
    dataIndex: "payment_method",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "payment_method"
  }, {
    title: "",
    dataIndex: "action",
    render: function render(s) {
      return /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(Button, {
          type: "default",
          onClick: function onClick() {
            setSelectedSettlement(s);
            setShowReceipt(true);
          },
          children: /*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(PrinterFill, {
              size: 22
            })
          })
        })
      });
    },
    key: "action"
  }];
  var handleExport = function handleExport() {
    var excel = new Excel();
    excel.addSheet("sheet").addColumns(cols).addDataSource(settlements, {
      str2Percent: true
    }).saveAs("exp.xlsx");
  };
  useEffect(function () {
    if (bill == null || bill == 'undefined') return;
    bill.bill_settlements.forEach(function (s) {
      setSettlements(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          date: s.created_at,
          amount: s.amount.toLocaleString("Fr"),
          user: s.user.prenom + " " + s.user.nom,
          payment_method: s.payment_method && s.payment_method.label,
          action: s
        }]);
      });
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 4,
          md: 4,
          sm: 4,
          children: bill.po && /*#__PURE__*/_jsx(Image, {
            src: Common.baseUrl + bill.po
          })
        }), /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Descriptions, {
            bordered: true,
            title: /*#__PURE__*/_jsx("b", {
              children: "INFOS COMMANDES"
            }),
            size: "small",
            column: 1,
            items: [{
              key: '1',
              label: /*#__PURE__*/_jsx("b", {
                children: "Date"
              }),
              children: /*#__PURE__*/_jsx(Moment, {
                date: bill.created_at,
                format: "DD/MM/YYYY"
              })
            }, {
              key: '2',
              label: /*#__PURE__*/_jsx("b", {
                children: "ID Command."
              }),
              children: /*#__PURE__*/_jsxs("span", {
                children: ["#CMDN", bill.id]
              })
            }, {
              key: '3',
              label: /*#__PURE__*/_jsx("b", {
                children: "Montant Total (Gnf)"
              }),
              children: /*#__PURE__*/_jsx("span", {
                children: bill.total_amount.toLocaleString("Fr")
              })
            }, {
              key: '3',
              label: /*#__PURE__*/_jsx("b", {
                children: "Total pay\xE9 (Gnf)"
              }),
              children: /*#__PURE__*/_jsx("span", {
                children: bill.paid_amount.toLocaleString("Fr")
              })
            }]
          })
        })]
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Table, {
            size: "small",
            columns: cols,
            bordered: true,
            loading: isDataLoading,
            dataSource: settlements,
            pagination: true
          })
        })
      })]
    }), selectedSettlement && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsxs("b", {
          children: [/*#__PURE__*/_jsx(CheckCircleFill, {
            size: 30
          }), " RECU"]
        }),
        width: "80%",
        open: showReceipt,
        onClose: function onClose() {
          setShowReceipt(false);
        },
        destroyOnClose: true,
        extra: [/*#__PURE__*/_jsx(ReactToPrint, {
          content: function content() {
            return ref.current;
          },
          children: /*#__PURE__*/_jsx(PrintContextConsumer, {
            children: function children(_ref2) {
              var handlePrint = _ref2.handlePrint;
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: handlePrint,
                children: /*#__PURE__*/_jsx("b", {
                  children: "IMPRIMER"
                })
              });
            }
          })
        })],
        children: /*#__PURE__*/_jsx("div", {
          ref: ref,
          style: {
            textAlign: 'center'
          },
          children: /*#__PURE__*/_jsx(Receipt, {
            settlement: selectedSettlement,
            company: bill.lead
          })
        })
      })
    })]
  });
};
export default SettlementHistory;